module.exports = __webpack_public_path__ + "img/battery-working-one.2c20d352.svg";